var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaupBlueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Haup_horizontal_logo",
    "data-name": "Haup horizontal logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.032,
    height: 23.639,
    viewBox: "0 0 122.032 23.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4813",
    "data-name": "Path 4813",
    d: "M104.505,115.486a2.354,2.354,0,0,1-1.664-4.018l6.352-6.352a2.354,2.354,0,1,1,3.329,3.328L106.17,114.8a2.34,2.34,0,0,1-1.665.689",
    transform: "translate(-90.116 -92.122)",
    fill: "#14499b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    d: "M2.354,115.488A2.354,2.354,0,0,1,.691,111.47l6.353-6.353a2.353,2.353,0,0,1,3.327,3.329L4.019,114.8a2.34,2.34,0,0,1-1.665.689",
    transform: "translate(-0.001 -92.124)",
    fill: "#14499b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4815",
    "data-name": "Path 4815",
    d: "M104.505,13.332a2.355,2.355,0,0,1-1.664-4.019l6.352-6.354a2.354,2.354,0,0,1,3.329,3.33l-6.353,6.352a2.348,2.348,0,0,1-1.665.691",
    transform: "translate(-90.116 -2.003)",
    fill: "#14499b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4816",
    "data-name": "Path 4816",
    d: "M2.354,13.332A2.355,2.355,0,0,1,.691,9.313L7.044,2.959a2.354,2.354,0,0,1,3.327,3.33L4.019,12.641a2.348,2.348,0,0,1-1.665.691",
    transform: "translate(-0.001 -2.003)",
    fill: "#14499b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4817",
    "data-name": "Path 4817",
    d: "M246.375,23.05V3.991a2.1,2.1,0,0,1,2.385-2.08,2,2,0,0,1,2.047,2.08v7.315h10.937V3.991a2.183,2.183,0,0,1,2.282-2.08,2.029,2.029,0,0,1,2.081,2.08V23.05a2.05,2.05,0,0,1-2.081,2.081,2.205,2.205,0,0,1-2.282-2.081V15.7H250.807V23.05a2.022,2.022,0,0,1-2.047,2.081,2.12,2.12,0,0,1-2.385-2.081",
    transform: "translate(-217.347 -1.686)",
    fill: "#14499b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4818",
    "data-name": "Path 4818",
    d: "M686.215,3.21a2.159,2.159,0,1,1,4.31,0V15.119c0,12.3-19.837,12.3-19.837,0V3.21a2.158,2.158,0,1,1,4.309,0V15.119c0,6.481,11.218,6.875,11.218,0Z",
    transform: "translate(-591.668 -0.817)",
    fill: "#14499b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4819",
    "data-name": "Path 4819",
    d: "M882.84,4.337a2.269,2.269,0,0,1,2.244-2.277h7.622c4.291,0,8.151,2.871,8.151,8.381a7.815,7.815,0,0,1-8.151,8.117H887.2v4.355a2.074,2.074,0,0,1-2.112,2.277,2.229,2.229,0,0,1-2.244-2.277Zm4.355,1.88v8.217h5.51a4.111,4.111,0,0,0,0-8.217Z",
    transform: "translate(-778.824 -1.817)",
    fill: "#14499b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M465.635,20.544c-.782-1.486-9-17.932-9.632-19.177A2.218,2.218,0,0,0,453.909,0a2.386,2.386,0,0,0-2.193,1.561c-.746,1.426-8.775,17.077-9.693,18.983a2.418,2.418,0,0,0,1.087,2.967c.321.126,2.375.518,3.154-1.214.469-1.043.932-1.91,1.387-2.841H460.14c.027,0,.053,0,.079,0-.039.035-.062.053-.062.053l1.4,2.8a2.02,2.02,0,0,0,2.9,1.076c.473-.173,1.952-1.355,1.171-2.84m-11.73-13.9,3.873,8.384h-8.026l.4-.848Z",
    transform: "translate(-389.776 0)",
    fill: "#14499b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaupBlueLogo);
export default __webpack_public_path__ + "static/media/HaupBlueLogo.bcf27345.svg";
export { ForwardRef as ReactComponent };